import BaseService from '../BaseService';

class FaqRecebidasService extends BaseService {
    constructor() {
        super('/programas/faq-recebidas/');
    }
}

export default new FaqRecebidasService();
